"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Highcharts = __importStar(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const HighChart = (props) => {
    const mq = window.matchMedia("(max-width: 767px)");
    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            height: mq.matches ? 152 : 184,
            width: mq.matches ? 152 : 184
        },
        title: {
            text: props.text,
            align: "center",
            verticalAlign: "middle",
            y: 20,
            style: {
                fontFamily: "Nimbus Sans Regular",
                fontSize: mq.matches ? "14px" : "16px",
                color: props.hasError
                    ? tokens.ColorFunctionalRed500
                    : tokens.ColorGrey800
            }
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false
                },
                startAngle: 0,
                endAngle: 360,
                center: ["50%", "50%"],
                size: mq.matches ? 144 : 176,
                borderWidth: 0,
                opacity: 1,
                colors: [
                    tokens.ColorBrandInteractiveBlue,
                    tokens.ColorBrandBrightBlue,
                    tokens.ColorChartingTeal100,
                    tokens.ColorChartingPurple500,
                    tokens.ColorWhite075
                ]
            }
        },
        series: [
            {
                type: "pie",
                innerSize: "75%",
                enableMouseTracking: false,
                data: props.data && props.data.length ? props.data : [0, 0, 0, 0, 100]
            }
        ]
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(highcharts_react_official_1.default, Object.assign({ highcharts: Highcharts, options: options }, props))));
};
exports.default = HighChart;
//# sourceMappingURL=PieChart.js.map